import { lazy } from "react";
import { addHandleRoute, createRoute } from "../utils/RouteHelper";

// route
export const whsRoute = createRoute({
    path: "/warehouse",
    name: "menu.warehouse",
    icon: "warehouse",
    accCode: "cekgudang",
    exclude_breadcrumbs: true,
});

export const stockRoute = createRoute({
    path: `${whsRoute.path}/item_stock`,
    name: "whs_itemstock.",
    code: 'IS',
    accCode: "",
    parentCode: whsRoute.accCode,
});

export const stockDetailRoute = createRoute({
    path: `${stockRoute.path}/detail`,
    name: "whs_itemstock.detail",
    code: 'IS',
    accCode: "",
    parentCode: whsRoute.accCode,
});

export const itemInRoute = createRoute({
    path: `${whsRoute.path}/view_item_in`,
    name: "whs_itemin.",
    code: 'IIN',
    accCode: "",
    parentCode: whsRoute.accCode,
});

export const itemOutRoute = createRoute({
    path: `${whsRoute.path}/view_item_out`,
    name: "whs_itemout.",
    code: 'IOUT',
    accCode: "",
    parentCode: whsRoute.accCode,
});

export const returnSupplierRoute = createRoute({
    path: `${whsRoute.path}/retur_supplier`,
    name: "whs_returnsup.",
    code: 'RSUP',
    accCode: "",
    parentCode: whsRoute.accCode,
});

export const returnSupplierDetailRoute = createRoute({
    path: `${returnSupplierRoute.path}/detail`,
    name: "whs_returnsup.detail",
    code: 'RSUP',
    accCode: "",
    parentCode: whsRoute.accCode,
});

export const returnCustomerRoute = createRoute({
    path: `${whsRoute.path}/retur_customer`,
    name: "whs_returncus.",
    code: 'RCUS',
    accCode: "",
    parentCode: whsRoute.accCode,
});

export const returnCustomerDetailRoute = createRoute({
    path: `${returnCustomerRoute.path}/detail`,
    name: "whs_returncus.detail",
    code: 'RCUS',
    accCode: "",
    parentCode: whsRoute.accCode,
});

export const depreciationRoute = createRoute({
    path: `${whsRoute.path}/view_depreciation`,
    name: "Penyusutan",
    code: 'DEP',
    accCode: "",
    parentCode: whsRoute.accCode,
});

export const whsSerialNumRoute = createRoute({
    path: `${whsRoute.path}/view_serial_number`,
    name: "whs_serialnumber.",
    code: 'SN',
    accCode: "",
    parentCode: whsRoute.accCode,
});

export const itemMoveRoute = createRoute({
    path: `${whsRoute.path}/item_move_list`,
    name: "whs_itemmove.",
    code: 'IM',
    accCode: "",
    parentCode: whsRoute.accCode,
});

export const itemMoveDetailRoute = createRoute({
    path: `${itemMoveRoute.path}/detail`,
    name: "whs_itemmove.detail",
    code: 'IM',
    accCode: "",
    parentCode: whsRoute.accCode,
});

// component 
const Warehouse = lazy(() => import("../page/warehouse/Warehouse"));
const ItemStock = lazy(() => import("../page/warehouse/item_stock/ItemStock"));
const ItemStockDetail = lazy(() => import("../page/warehouse/item_stock/detail/ItemStockDetail"));
const ItemIn = lazy(() => import("../page/warehouse/item_in/ItemIn"));
const ItemOut = lazy(() => import("../page/warehouse/item_out/ItemOut"));
const ItemMove = lazy(() => import("../page/warehouse/item_move/ItemMove"));
const ItemMoveView = lazy(() => import("../page/warehouse/item_move/view/ItemMoveView"));
const ReturnSupplier = lazy(() => import("../page/warehouse/return_supplier/ReturnSupplier"));
const ReturnSupplierView = lazy(() => import("../page/warehouse/return_supplier/view/ReturnSupplierView"));
const ReturnCustomer = lazy(() => import("../page/warehouse/return_customer/ReturnCustomer"));
const ReturnCustomerView = lazy(() => import("../page/warehouse/return_customer/view/ReturnCustomerView"));
const ItemDepreciation = lazy(() => import("../page/warehouse/item_depreciation/ItemDepreciation"));
const WhsSerialNumber = lazy(() => import("../page/warehouse/serial_number/SerialNumber"));

export const warehouseTabRoutes = [
    stockRoute,
    itemInRoute,
    itemOutRoute,
    returnSupplierRoute,
    returnCustomerRoute,
    whsSerialNumRoute,
    // depreciationRoute,
    itemMoveRoute,
];

export const warehouseMutationRoutes = [
    itemMoveDetailRoute,
    returnSupplierDetailRoute,
    returnCustomerDetailRoute,
    stockDetailRoute
]

export const warehouseRoutes = {
    element: <Warehouse />,
    children: addHandleRoute([
        { ...stockRoute, element: <ItemStock /> },
        { ...stockDetailRoute, element: <ItemStockDetail /> },
        { ...itemInRoute, element: <ItemIn /> },
        { ...itemOutRoute, element: <ItemOut /> },
        { ...itemMoveRoute, element: <ItemMove /> },
        { ...itemMoveDetailRoute, element: <ItemMoveView /> },
        { ...returnSupplierRoute, element: <ReturnSupplier /> },
        { ...returnSupplierDetailRoute, element: <ReturnSupplierView /> },
        { ...returnCustomerRoute, element: <ReturnCustomer /> },
        { ...returnCustomerDetailRoute, element: <ReturnCustomerView /> },
        { ...depreciationRoute, element: <ItemDepreciation /> },
        { ...whsSerialNumRoute, element: <WhsSerialNumber /> },
    ]),
};